<template>
  <div
    v-if="isVisible"
    class="tapa-emea-banner"
  >
    <div class="tapa-emea-content">
      <div class="tapa-emea-brand-section">
        <div>
          <img
            class="reelables-logo"
            :src="logo"
            :height="40"
            alt="Reelables logo"
          >
          <div class="tapa-emea-text">
            <p>
              <strong>Find us on the</strong>
            </p>
            <p
              v-if="boothNumber"
              class="booth-text"
            >
              {{ boothNumber }}
            </p>
          </div>
        </div>
        <img
          src="https://tapaemea.org/wp-content/uploads/2022/06/Tapa-EMEA-Logo-TM-2446-x-639.jpeg"
          alt="TAPA EMEA 2026 Logo"
          class="tapa-emea-logo"
        >
      </div>

      <div class="tapa-emea-actions">
        <p class="find-us-text">
          <strong>Find us at</strong>
        </p>
        <span
          v-if="boothNumber"
          class="booth-badge"
        >{{ boothNumber }}</span>
        <button
          v-if="hasButton"
          class="banner-button"
          @click="clickButton"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LogoImage from '../../../assets/images/reelables-r-logo-white.svg';

export default {
  name: 'HomeDeliveryWorld2026Banner',
  props: {
    boothNumber: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    logo() {
      return LogoImage;
    },
    hasButton() {
      return !!this.buttonText;
    },
  },
  methods: {
    clickButton() {
      this.$emit('button-click');
    },
  },
};
</script>

<style scoped lang="scss">
.tapa-emea-banner {
  position: absolute;
  top: 0;
  background: linear-gradient(90deg, #466BB4 0%, #12110B 75%);
  color: #ffffff;
  padding: 8px;
  border-bottom: 3px solid #01A2FA;
  font-family: Arial, sans-serif;
  width: 100%;
  z-index: 10;
}

.tapa-emea-content {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tapa-emea-brand-section {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  > div {
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 20px;
  }
}

.tapa-emea-logo {
  height: 45px; /* Adjust height as needed */
  width: auto;
}

.reelables-logo {
  margin-left: -8px;
}

.tapa-emea-text p {
  margin: 0;
  font-size: 14px;
}

.details {
  display: block;
  font-size: 12px;
  color: #cbd5e0;
}

.tapa-emea-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.tapa-emea-text{
  display: none;
}

.booth-badge {
  background-color: lighten(#01A2FA, 20%);
  color: #000;
  padding: 3px 8px;
  font-weight: bold;
  font-size: 14px;
  border-radius: 2px;
}

.banner-button {
  background-color: #ffffff;
  color: #002e5d;
  padding: 6px 14px;
  text-decoration: none;
  font-weight: bold;
  font-size: 13px;
  border-radius: 4px;
  transition: 0.2s ease-in-out;
}

.banner-button:hover {
  background-color: #d4af37;
  color: #ffffff;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .tapa-emea-logo {
    height: 40px;
  }
  .details {
    display: inline;
    margin-left: 5px;
  }
  .tapa-emea-text p {
    font-size: 12px;
  }
  .tapa-emea-text {
    display: block;
  }
  .booth-badge, .find-us-text {
    display: none; /* Hide booth on small mobile to save space */
  }
}
</style>
